import * as z from "zod/v4";

export const respondToCatalogAgentTool = {
  name: "respondToCatalogAgentTool" as const,
  input: z.object({
    threadId: z.string(),
    toolCallId: z.string(),
    result: z.unknown(),
  }),
  output: z.object({ success: z.boolean() }),
};
